module.exports = __webpack_public_path__ + "static/media/feature-4.948577f5.svg";